/* ============================================================
   CLICK2BUY — Desktop empty-focus search panel
   Scope: custom desktop search only.
   Does not patch or replace Shopify's predictive-search.js.
   ============================================================ */

(function () {
  var DESKTOP_SEARCH_SELECTOR = '.c2b-header-search-desktop predictive-search[data-c2b-desktop-search]';
  var ENHANCED_ATTR = 'data-c2b-enhanced';
  var HAS_QUERY_ATTR = 'data-c2b-has-query';
  var EMPTY_PANEL_ATTR = 'data-c2b-empty-focus-panel';
  var TEMPLATE_SELECTOR = 'template[data-c2b-empty-focus-template]';

  function getQuery(input) {
    return input && input.value ? input.value.trim() : '';
  }

  function setHasQueryState(predictiveSearch, input) {
    if (getQuery(input).length > 0) {
      predictiveSearch.setAttribute(HAS_QUERY_ATTR, 'true');
    } else {
      predictiveSearch.removeAttribute(HAS_QUERY_ATTR);
    }
  }

  function getResultsContainer(predictiveSearch) {
    return predictiveSearch.querySelector('[data-predictive-search]');
  }

  function getEmptyPanelTemplate(predictiveSearch) {
    return predictiveSearch.querySelector(TEMPLATE_SELECTOR);
  }

  function templateHasItems(template) {
    if (!template || !template.content) return false;
    return Boolean(template.content.querySelector('li[role="option"]'));
  }

  function setStatusText(predictiveSearch) {
    var statusElement = predictiveSearch.querySelector('.predictive-search-status');
    var countElement = predictiveSearch.querySelector('[data-predictive-search-live-region-count-value]');

    if (!statusElement || !countElement) return;

    statusElement.setAttribute('aria-hidden', 'false');
    statusElement.textContent = countElement.textContent.trim();

    window.setTimeout(function () {
      statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  function setOpenState(predictiveSearch, input) {
    var resultsContainer = getResultsContainer(predictiveSearch);

    if (resultsContainer) {
      var header = document.querySelector('.section-header');
      var headerBottom = header ? header.getBoundingClientRect().bottom : 0;
      resultsContainer.style.maxHeight = window.innerHeight - headerBottom + 'px';
    }

    predictiveSearch.setAttribute('results', 'true');
    predictiveSearch.setAttribute('open', 'true');
    predictiveSearch.setAttribute(EMPTY_PANEL_ATTR, 'true');
    predictiveSearch.removeAttribute('loading');
    input.setAttribute('aria-expanded', 'true');
    predictiveSearch.isOpen = true;

    setStatusText(predictiveSearch);
  }

  function closeEmptyPanel(predictiveSearch, input) {
    if (!predictiveSearch.hasAttribute(EMPTY_PANEL_ATTR)) return;

    var resultsContainer = getResultsContainer(predictiveSearch);
    var selected = predictiveSearch.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', 'false');

    predictiveSearch.removeAttribute(EMPTY_PANEL_ATTR);
    predictiveSearch.removeAttribute('results');
    predictiveSearch.removeAttribute('open');
    predictiveSearch.removeAttribute('loading');
    predictiveSearch.isOpen = false;

    if (input) {
      input.setAttribute('aria-expanded', 'false');
      input.setAttribute('aria-activedescendant', '');
    }

    if (resultsContainer) {
      resultsContainer.removeAttribute('style');
      resultsContainer.innerHTML = '';
    }
  }

  function openEmptyPanel(predictiveSearch, input) {
    if (!predictiveSearch || !input || getQuery(input).length > 0) return;

    var template = getEmptyPanelTemplate(predictiveSearch);
    var resultsContainer = getResultsContainer(predictiveSearch);

    if (!templateHasItems(template) || !resultsContainer) return;

    resultsContainer.innerHTML = template.innerHTML;
    setOpenState(predictiveSearch, input);
  }

  function handleEmptyPanelKeyboard(event, predictiveSearch, input) {
    if (!predictiveSearch.hasAttribute(EMPTY_PANEL_ATTR)) return;
    if (getQuery(input).length > 0) return;

    if (event.code === 'ArrowUp') {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (typeof predictiveSearch.switchOption === 'function') predictiveSearch.switchOption('up');
      return;
    }

    if (event.code === 'ArrowDown') {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (typeof predictiveSearch.switchOption === 'function') predictiveSearch.switchOption('down');
      return;
    }

    if (event.code === 'Enter') {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (typeof predictiveSearch.selectOption === 'function') predictiveSearch.selectOption();
      return;
    }

    if (event.code === 'Escape') {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeEmptyPanel(predictiveSearch, input);
    }
  }

  function enhancePredictiveSearch(predictiveSearch) {
    if (!predictiveSearch || predictiveSearch.getAttribute(ENHANCED_ATTR) === 'true') return;

    var input = predictiveSearch.querySelector('input[type="search"]');
    if (!input) return;

    predictiveSearch.setAttribute(ENHANCED_ATTR, 'true');
    setHasQueryState(predictiveSearch, input);

    input.addEventListener('input', function () {
      setHasQueryState(predictiveSearch, input);

      if (getQuery(input).length > 0) {
        closeEmptyPanel(predictiveSearch, input);
      }
    });

    input.addEventListener('focus', function () {
      setHasQueryState(predictiveSearch, input);
      openEmptyPanel(predictiveSearch, input);
    });

    if (input.form) {
      input.form.addEventListener('reset', function () {
        window.requestAnimationFrame(function () {
          setHasQueryState(predictiveSearch, input);

          if (document.activeElement === input) {
            openEmptyPanel(predictiveSearch, input);
          }
        });
      });
    }

    predictiveSearch.addEventListener(
      'keyup',
      function (event) {
        handleEmptyPanelKeyboard(event, predictiveSearch, input);
      },
      true
    );

    predictiveSearch.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (!predictiveSearch.contains(document.activeElement)) {
          closeEmptyPanel(predictiveSearch, input);
        }
      });
    });
  }

  function initDesktopHeaderSearch() {
    document.querySelectorAll(DESKTOP_SEARCH_SELECTOR).forEach(enhancePredictiveSearch);
  }

  function boot() {
    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements
        .whenDefined('predictive-search')
        .then(initDesktopHeaderSearch)
        .catch(initDesktopHeaderSearch);
      return;
    }

    initDesktopHeaderSearch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
